module.exports = __webpack_public_path__ + "img/icon_pay_tickBig.1768119790257.png";